module.exports = __webpack_public_path__ + "img/p-5.94450572.png";